<template>
  <div>
    <b-row>
      <b-col cols="12" class="head">
        <div class="containerr">
          <h2 class="ruta">
            {{ ruta }}
          </h2>
          <p class="span">{{ span }}</p>
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      ruta: "Comparador",
      span: "Herramienta para analizar el desempeño entre instituciones",
    };
  },
};
</script>

<style scoped>
.row {
  margin: 0;
  background: #052333;
  height: 140px;
}

.head {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  background: #052333;
}

.containerr {
  margin: 32px;
}

.container {
  margin-top: 30px;
}

.ruta {
  color: #fff;
}

.span {
  color: #fff;
}

.row-Two {
  margin: 0;
  background: #e0e0e0;
  height: 140px;
}

.dos {
  margin-top: -5px;
}

.title {
  text-align: center;
  color: #052333;
}

.select-div {
  text-align: end;
}

.select {
  border: none;
  width: 280px;
  font-size: 16px;
  color: #052333;
  margin-left: -10px;
}

.row-select {
  background: #e0e0e0;
  height: 50px;
}

.select-two {
  border: none;
  width: 280px;
  font-size: 16px;
  color: #052333;
}

@media screen and (max-width: 768px) {
  .title {
    font-size: 14px;
  }

  .select {
    width: 200px;
    font-size: 12px;
  }

  .select-two {
    width: 200px;
    font-size: 12px;
  }
}

@media screen and (max-width: 510px) {
  .ruta {
    font-size: 16px;
  }

  .span {
    font-size: 10px;
  }
  .title {
    font-size: 11px;
  }

  .select {
    width: 150px;
    font-size: 10px;
  }

  .select-two {
    width: 150px;
    font-size: 10px;
  }
}

@media screen and (max-width: 399px) {
  .select {
    width: 110px;
    font-size: 9px;
  }

  .select-two {
    width: 110px;
    font-size: 9px;
  }
}
</style>
